// Libs
import React, { useEffect, useState } from 'react';
import { ReactElement } from 'react';
// App
import { FormControl, MenuItem, Select, Stack, Typography, SelectChangeEvent, Icon } from 'ui-components';
import { FiltersProps } from './filters.interfaces';
import { FILTER_LABELS } from './filters.constants';

const Filters = (props: FiltersProps): ReactElement => {
  const { initialValue, onFiltersChange, isFullWidth } = props;
  const [state, setState] = useState('ALL');

  useEffect(() => {
    if (initialValue === true) {
      setState('ONLINE');
    } else if (initialValue === false) {
      setState('ONSITE');
    } else {
      setState('ALL');
    }
  }, [initialValue]);

  const handleChange = (event: SelectChangeEvent) => {
    const updatedState = event.target.value;

    setState(updatedState);

    if (updatedState == 'ONLINE') {
      onFiltersChange(true);
    } else if (updatedState == 'ONSITE') {
      onFiltersChange(false);
    } else {
      onFiltersChange(null);
    }
  };

  return (
    <Stack width={(isFullWidth && '100%') || 250}>
      <FormControl color="secondary" size="small">
        <Select
          value={state}
          onChange={handleChange}
          size="small"
          renderValue={(selected: string) => (
            <Typography variant="body2" color="textPrimary" fontWeight={500}>
              {FILTER_LABELS[selected]}
            </Typography>
          )}
        >
          <MenuItem value="ALL">
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} width="100%">
              <Typography variant="body2" color="textPrimary" fontWeight={500}>
                Tous types de paiement
              </Typography>
              {state == 'ALL' && <Icon name="check" size="small" color="tertiary" />}
            </Stack>
          </MenuItem>
          <MenuItem value="ONLINE">
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} width="100%">
              <Typography variant="body2" color="textPrimary" fontWeight={500}>
                Paiement en ligne
              </Typography>
              {state == 'ONLINE' && <Icon name="check" size="small" color="tertiary" />}
            </Stack>
          </MenuItem>
          <MenuItem value="ONSITE">
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} width="100%">
              <Typography variant="body2" color="textPrimary" fontWeight={500}>
                Paiement au retrait
              </Typography>
              {state == 'ONSITE' && <Icon name="check" size="small" color="tertiary" />}
            </Stack>
          </MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};

export default Filters;
